export default "__VITE_ASSET__qI44yTVe__"